import { GetServerSideProps } from 'next';
import React from 'react';
import Layout from '../../../components/Layout/Layout';
import BenefitsPageComponent from '../../../components/Solutions/Insurance/BenefitsPageComponent';
import { apiRequest } from '../../../components/util/requests/requests';
import { PageMetadata } from '../../../components/util/SeoMetaInformationComponent/SeoMetaInformationComponent';

export interface BenefitsProps {
    pageMetadata?: PageMetadata;
}

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
    const pageMetadata = await apiRequest(
        '/meta-pages?filters[key]=SOLUTIONS_BENEFITS_PAGE&populate[0]=seo'
    );

    return {
        props: {
            pageMetadata:
                pageMetadata.data && pageMetadata.data.length > 0 ? pageMetadata.data[0] : null,
        },
    };
};

const Benefits = ({ pageMetadata }: BenefitsProps) => (
    <Layout
        seoMetadata={pageMetadata?.seo}
        defaultMetaTitle={'Noria.no - Solutions - Insurance - Benefits'}
    >
        <BenefitsPageComponent />
    </Layout>
);

export default Benefits;
